import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RecoverUserIDRequest } from 'services/recoverUserId/typings'
import recoverUserIdAPI, {
  GetRecoverUserIdPayload
} from 'services/recoverUserId'
import { ErrorDataResponse, ServerError } from 'typings/serverError'

interface RecoverUserIdState {
  userId: string
  errorMessage: string
  isLoading: boolean
}

export const initState: RecoverUserIdState = {
  userId: '',
  errorMessage: '',
  isLoading: false
}

export const getUserId = createAsyncThunk(
  'recoverUserIdSlice/getUserId',
  async (payload: GetRecoverUserIdPayload, { rejectWithValue }) => {
    try {
      return await recoverUserIdAPI.getRecoverUserIdEligibilityCheck(payload)
    } catch (error) {
      return rejectWithValue(error as ErrorDataResponse)
    }
  }
)

const recoverUserIdSlice = createSlice({
  name: 'recoverUserIdSlice',
  initialState: initState,
  reducers: {
    clearErrorMessage: (state: RecoverUserIDRequest) => {
      state.errorMessage = ''
    },
    exitRecoverUserId: (state: RecoverUserIDRequest) => {
      state.errorMessage = ''
      state.userId = ''
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getUserId.pending, state => {
        state.isLoading = true
        state.errorMessage = ''
      })
      .addCase(getUserId.fulfilled, (state, { payload }) => {
        state.userId = payload.userId
        state.isLoading = false
        state.errorMessage = ''
      })
      .addCase(getUserId.rejected, (state, { payload }) => {
        const { response, statusCode } = payload as ServerError
        const errorCode: string = response?.businessErrors?.[0]?.code

        state.errorMessage =
          errorCode || `unknown error. status code: ${statusCode}`
        state.isLoading = false
      })
  }
})

export const { clearErrorMessage, exitRecoverUserId } =
  recoverUserIdSlice.actions

export default recoverUserIdSlice.reducer
